import { useSiteData } from "../../context/SiteData";
import { Reveal } from "./Reveal";
import { optImg } from "../../lib/img";

export const ClosingNote = () => {
  const { content } = useSiteData();
  if (!content.closing_text && !content.closing_photo) return null;
  return (
    <section className="relative py-14 sm:py-20 overflow-hidden" data-testid="closing-note-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8 text-center sm:text-start">
            {content.closing_photo && (
              <img
                src={optImg(content.closing_photo, 600)}
                alt={content.closing_name || "Voyage Switzerland"}
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white shadow-xl shadow-[#0b132b]/15 shrink-0 bg-white"
                data-testid="closing-note-photo"
              />
            )}
            <div>
              <p className="text-base sm:text-lg text-slate-600 leading-relaxed font-medium" data-testid="closing-note-text">
                {content.closing_text}
              </p>
              {content.closing_name && (
                <p className="mt-3 font-display font-extrabold text-[#0b132b]" data-testid="closing-note-name">
                  {content.closing_name}
                </p>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
